import * as Input from "../../components/Form/Input";
import { Button } from "../../components/Button";
import { useState } from "react";
import { twMerge } from "tailwind-merge";
import { useStore } from "../../store";
import api from "../../service/api";
import { toast } from "react-toastify";
import { useLoading } from "../../store/useLoading";
import { useTabContext } from ".";
import { Loading } from "../../components/Loading";

export function CreateIngressos() {
  const { setCurrentTab } = useTabContext();
  const loading = useLoading((store) => store.isLoading);
  const setLoading = useLoading((store) => store.setLoading);
  const events = useStore((store) => store.events);

  const [ticketValue, setTicketValue] = useState("");
  const [event, setEvent] = useState("");

  const handleSubmint = async (e: React.FormEvent<HTMLFormElement>) => {
    setLoading(true)
    e.preventDefault();

    const convertToCent = parseFloat(ticketValue) * 100

    try {
      await api.post('tickets', {
        value: convertToCent,
        event_id: event
      })

      toast.success("Evento cadastrado com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      setTicketValue("")
      setEvent("")
      setCurrentTab("tab1")

    } catch (error: any) {
      toast.error(error.response.data.message || "Erro ao cadastrar um ingresso.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setLoading(false)
    }
  };

  function handleCancel() {
    setTicketValue("");
    setEvent("");
    setCurrentTab("tab1");
  }

  return (
    <>
      {loading && <Loading />}
      {!loading && (
        <form
          id="company"
          className="mt-10 flex w-full flex-col gap-5 divide-y divide-zinc-200 dark:divide-zinc-800"
          onSubmit={handleSubmint}
        >
          <div className="grid gap-3 lg:grid-cols-form">
            <label
              htmlFor="ticket"
              className="text-sm font-medium text-zinc-700 dark:text-zinc-100"
            >
              Valor
            </label>
            <div className="">
              <Input.Root>
                <Input.Control
                  name="ticket"
                  placeholder="R$ 00,00"
                  id="ticket"
                  type="text"
                  value={ticketValue}
                  onChange={(e) => setTicketValue(e.target.value)}
                />
              </Input.Root>
            </div>
          </div>

          <div className="grid gap-3 lg:grid-cols-form pt-5">
            <label
              htmlFor="event"
              className="text-sm font-medium text-zinc-700 dark:text-zinc-100"
            >
              Evento
            </label>
            <select
              id="event"
              name="event"
              value={event}
              onChange={(e) => setEvent(e.target.value)}
              className={twMerge(
                "flex items-center gap-2 rounded-lg border border-zinc-300 px-3 py-2 shadow-sm outline-none bg-transparent text-zinc-900",
                "focus-within:border-violet-300 focus-within:ring-4 focus-within:ring-violet-100 dark:focus-within:border-violet-500 dark:focus-within:ring-violet-500/10"
              )}
            >
              <option value="">.:Selecione um evento:.</option>
              {events.map((event) => {
                return (<option key={event.id} value={event.id}>{event.name}</option>)
              })}
            </select>
          </div>

          <div className="flex items-center justify-end gap-2 pt-5">
            <Button type="button" variant="outline" onClick={handleCancel}>
              Cancelar
            </Button>
            <Button type="submit" form="company" variant="primary">
              Salvar
            </Button>
          </div>
        </form >
      )}
    </>
  );
}
